import axios from 'axios';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'x-client-domain': window.location.hostname
    // 'Content-Type': 'application/json'
  },
  timeout: 30000 // 30 seconds
});

// apiClient.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem('token');
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => {
//     console.error('Request Error:', error);
//     return Promise.reject(error);
//   }
// );

// apiClient.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     const message = error.response?.data?.message || error.message;

//     switch (error.response?.status) {
//       case 401:
//         toast.error('Session expired. Please login again.');
//         // Redirect to login or handle auth error
//         break;
//       case 403:
//         toast.error('You do not have permission to perform this action');
//         break;
//       case 404:
//         toast.error('Resource not found');
//         break;
//       case 500:
//         toast.error('Server error. Please try again later');
//         break;
//       default:
//         toast.error(message || 'An unexpected error occurred');
//     }
//     return Promise.reject(error);
//   }
// );

export default apiClient;
